<template>
  <div class="layout-container">
    <el-row class="mb20" :gutter="20">
      <el-col :span="12">
        <order-bar-card :nowDate="nowDate" @changeNowDate="changeNowDate" />
      </el-col>
      <el-col :span="12">
        <order-bar-card :nowDate="nowMonth" dateType="month" @changeMonthDate="changeMonthDate" />
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="8">
        <order-amount-card card-title="今日金额总计" desc="今日业绩" :amount="todayAmount" color="#F86A72" />
      </el-col>
      <el-col :span="8">
        <order-amount-card card-title="本月续费客户金额" desc="本月续费客户金额" :amount="monthRenewAmount" />
      </el-col>
      <el-col :span="8">
        <order-amount-card card-title="本月业绩总额" desc="本月业绩总额" :amount="monthAmount" color="#ffc60b" />
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="8" style="height: 388px">
        <order-amount-card card-title="上周业绩" desc="上周业绩汇总金额" :amount="lastWeekAmount" color="#ffc60b" />
      </el-col>
      <el-col :span="16">
        <order-bar-card :nowDate="lastWeekDate" dateType="lastWeek" @changeMonthDate="changeLastWeekDate" />
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="8" style="height: 388px">
        <order-amount-card card-title="本周业绩" desc="本周业绩汇总金额" :amount="weekSum" color="#ffc60b" />
      </el-col>
      <el-col :span="16">
        <order-bar-card :nowDate="weekDate" dateType="week" @changeMonthDate="changeWeekDate" />
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="24">
        <order-line-card />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import OrderBarCard from '@/pages/data_overview/common/OrderBarCard'
import OrderAmountCard from './common/OrderAmountCard';
import OrderLineCard from './common/OrderLineCard'
export default {
  name: "GsOverview",
  components: { OrderBarCard, OrderAmountCard, OrderLineCard },
  props: {
  },
  watch: {
  },
  data() {
    return {
      nowDate: [],
      nowMonth: [],
      weekDate: [],
      lastWeekDate: [],
      weekSum: 0,
      todayAmount: 0,
      lastWeekAmount: 0,
      monthAmount: 0,
      monthRenewAmount: 0
    };
  },
  computed: {
  },
  methods: {
    formatDate () {
      let date = new Date()
      let year = date.getFullYear()
      let month = (1 + date.getMonth()).toString()
      month = month.padStart(2, '0')
      let day = date.getDate().toString()
      day = day.padStart(2, '0')

      let dateStr = year + '-' + month + '-' + day
      this.nowDate = [dateStr, dateStr]

      let monthStr = year + '-' + month
      this.nowMonth = [monthStr, monthStr]
      console.log('date', this.nowDate)

      // return year + '-' + month + '-' + day
    },
    setWeekStartAndEnd () {
      const today = new Date()

      // 获取当前星期几，0 表示星期日，6 表示星期六
      const dayOfWeek = today.getDay()
      // 获取今天的日期
      const dayOfMonth = today.getDate()
      // 计算本周的第一天（星期一）
      const firstDayOfWeek = new Date(today.setDate(dayOfMonth - dayOfWeek + (dayOfWeek === 0 ? -6 : 1)))
      // 计算本周的最后一天（星期日）
      const lastDayOfWeek = new Date(today.setDate(firstDayOfWeek.getDate() + 6))
      this.weekDate = [firstDayOfWeek.toISOString().split('T')[0], lastDayOfWeek.toISOString().split('T')[0]]
    },
    setLastWeekStartAndEnd () {
      const today = new Date()
      // 获取今天是星期几，0 表示星期日，设置为7方便计算
      const dayOfWeek = today.getDay() === 0 ? 7 : today.getDay()
      // 获取今天的日期
      const dayOfMonth = today.getDate()
      // 计算上周的第一天（星期一）
      const firstDayOfLastWeek = new Date(today.setDate(dayOfMonth - dayOfWeek - 6))
      // 计算上周的最后一天（星期日）
      const lastDayOfLastWeek = new Date(today.setDate(firstDayOfLastWeek.getDate() + 6))
      this.lastWeekDate = [firstDayOfLastWeek.toISOString().split('T')[0], lastDayOfLastWeek.toISOString().split('T')[0]]
    },
    changeNowDate (val) {
      this.nowDate = val
    },
    changeMonthDate (val) {
      this.nowMonth = val
    },
    changeWeekDate (val) {
      this.weekDate = val
    },
    changeLastWeekDate (val) {
      this.lastWeekDate = val
    },
    amountSum () {
      this.$axios.get('/api/admin/data_overview/order_card_data')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            console.log(data)
            this.todayAmount = data.data.daySum
            this.weekSum = data.data.weekSum
            this.lastWeekAmount = data.data.lastWeekSum
            this.monthAmount = data.data.monthSum
            this.monthRenewAmount = data.data.monthRenewSum
          }
        })
    }
  },
  mounted() {
    this.formatDate()
    this.setWeekStartAndEnd()
    this.setLastWeekStartAndEnd()
    this.amountSum()
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.clearfix:before,
.clearfix:after
.text-r
  text-align: right
.layout-container
  marginLeft()
  .mb20
    margin-bottom: .4rem
</style>



// WEBPACK FOOTER //
// src/pages/data_overview/GsOverview.vue